import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  AuthRoutes,
  RouteParamsTypes,
  Modules,
  NonAuthRoutes,
  PermissionModulesEnum,
  PermissionActionsEnum,
} from '../enums';
import { MenuTextMapping } from '../utils/appConstant';
import { redirectBasedOnPermission } from '../utils/methods';
import { AuthContext } from '../contexts/AuthContext';
import ProtectedRoute from '../components/ProtectedRoute';
import UploadStock from '../modules/monthlyStock/uploadStock';
import MonthlyStockList from '../modules/monthlyStock/list';
import VerifyStock from '../modules/monthlyStock/verifyStock';

const MonthlyStock: React.FC = () => {
  const { isSystemAdmin, permissions } = useContext(AuthContext);
  return (
    <Routes>
      <Route
        path={AuthRoutes.monthlyStockList}
        element={
          <ProtectedRoute
            component={MonthlyStockList}
            accessibleTo={[{ [PermissionModulesEnum.MonthlyStock]: [PermissionActionsEnum.View] }]}
          />
        }
      />

      <Route
        path={AuthRoutes.verifyStock}
        element={
          <ProtectedRoute
            component={VerifyStock}
            accessibleTo={[{ [PermissionModulesEnum.MonthlyStock]: [PermissionActionsEnum.View] }]}
          />
        }
      />

      <Route
        path={AuthRoutes.uploadStock}
        element={
          <ProtectedRoute
            component={UploadStock}
            accessibleTo={[{ [PermissionModulesEnum.MonthlyStock]: [PermissionActionsEnum.View] }]}
          />
        }
      />

      <Route
        path={RouteParamsTypes.blank}
        element={
          <Navigate
            replace
            to={{
              pathname:
                redirectBasedOnPermission(isSystemAdmin, permissions, MenuTextMapping.monthlyStockList) ||
                Modules.error + NonAuthRoutes.forbidden,
            }}
          />
        }
      />
      <Route
        path={RouteParamsTypes.any}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
    </Routes>
  );
};

export default MonthlyStock;
